import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Fix from "./components/covfile/Fix";
import FilesDownloadPage from "./components/covfile/FilesDownloadPage";
import TasksPage from "./components/covfile/TasksPage";
import Coordinator from "./components/covfile/Coordinator";
import MentorsPage from "./components/covfile/MentorsPage";
import HelpRequestsColumn from "./components/covfile/HelpRequestsColumn";
import InstallSyrve from "./components/covfile/InstallSyrve";
import DutyPage from "./components/covfile/DutyPage";
import InstallSyrveFront from "./components/covfile/InstallSyrveFront";
import IntallSyrveAll from "./components/covfile/IntallSyrveAll";
import InstallSyrveFrontAll from "./components/covfile/InstallSyrveFrontAll";
import SuppliersPagePl from "./components/covfile/SuppliersPagePl";
import Registr from "./components/registr/Registr";
import Profile from "./components/profile/Profile";
import UserProfile from "./components/profile/UserProfile";
import AdminProfile from "./components/profile/AdminProfile";
import Login from "./components/login/Login";
import ForgotPassword from "./components/login/ForgotPassword";
import ResetPassword from "./components/login/ResetPassword";
import Price from "./components/price/Price";
import FopForm from "./components/fopForm/FopForm";
import ContractorSelector from "./components/fopForm/ContractorSelector";
import HeaderU from "./components/header/HeaderU";
import HeaderA from "./components/header/HeaderA";
import RestForm from "./components/rest/RestoForm";
import UserManagement from "./components/rest/UserManagement";
import RestInfo from "./components/restinfo/RestInfo";
import Home from "./components/covfile/Home";
import Events from "./components/events/Events";
import { useAuth } from './components/auth/Auth';
import { AuthProvider } from './components/auth/Auth';
import Directory from "./components/directory/Directory";
import Equip from "./components/directory/Equip";
import Info from "./components/restinfo/RestInfo";
import UserConfig from "./components/covfile/UserConfig";
import ChatAi from "./components/covfile/ChatAI";
import Template from "./components/covfile/Template";
import AccountModal from './components/covfile/ChatAI';
// Cases components (migrated from studio prototype)
import { 
  CasesComplex, 
  CasesPending, 
  CasesWorking, 
  CasesUnprocessed 
} from "./components/cases";

function ProtectedRoute({ children, allowedRule }) {
  const { user } = useAuth();
  const userRule = user?.role;
  const isAllowed = String(userRule) === allowedRule;
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function RoleBasedRoute({ children, allowedRoles }) {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user?.user_id) {
        setLoading(false);
        return;
      }
      try {
        const response = await fetch(`https://hub2.daolog.net/user-role/${user.user_id}`);
        if (response.ok) {
          const data = await response.json();
          setUserRole(data.role);
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserRole();
  }, [user?.user_id]);

  if (loading) {
    return <div>Завантаження...</div>;
  }

  const isAllowed = userRole && allowedRoles.includes(userRole);
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function ChooseHeader() {
  const { user } = useAuth();
  const userRule = user?.role;
  if (userRule === 1) {
    console.log(user);
    console.log("UserA");
    return <HeaderA />;
  }
  return <HeaderU />;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const refreshToken = localStorage.getItem('refreshToken');
    setIsLoggedIn(!!refreshToken);
  }, []);

  return (
    <BrowserRouter>
      <div className="forFooter">
        <div className="App">
          <AuthProvider>
            <ChooseHeader />
            
            <Routes>
              <Route path="/FilesDownloadPage" element={
                <ProtectedRoute allowedRule="0">
                  <FilesDownloadPage />
                </ProtectedRoute>
              } />
               <Route path="/TimeTracker" element={
                <ProtectedRoute allowedRule="0">
                  <Fix />
                </ProtectedRoute>
              } />
               <Route path="/TasksPage" element={
                <ProtectedRoute allowedRule="0">
                  <TasksPage />
                </ProtectedRoute>
              } />
              <Route path="/Coordinator" element={
                <RoleBasedRoute allowedRoles={["Тімлід", "Координатор"]}>
                  <Coordinator />
                </RoleBasedRoute>
              } />
               <Route path="/MentorsPage" element={
                <RoleBasedRoute allowedRoles={["Тімлід", "Координатор", "Ментор"]}>
                  <MentorsPage />
                </RoleBasedRoute>
              } />
               <Route path="/HelpRequestsColumn" element={
                <RoleBasedRoute allowedRoles={["Тімлід", "Координатор", "Ментор"]}>
                  <HelpRequestsColumn />
                </RoleBasedRoute>
              } />
              <Route path="/" element={
                <ProtectedRoute allowedRule="0">
                  <Home />
                </ProtectedRoute>
              } />
              <Route path="/InstallSyrve" element={
                <ProtectedRoute allowedRule="0">
                  <InstallSyrve />
                </ProtectedRoute>
              } />
               <Route path="/DutyPage" element={
                <ProtectedRoute allowedRule="0">
                  <DutyPage />
                </ProtectedRoute>
              } />
               <Route path="/InstallSyrveFront" element={
                <ProtectedRoute allowedRule="0">
                  <InstallSyrveFront />
                </ProtectedRoute>
              } />
               
                 <Route path="/IntallSyrveAll" element={
                <ProtectedRoute allowedRule="1">
                  <IntallSyrveAll />
                </ProtectedRoute>
              } />
                <Route path="/InstallSyrveFrontAll" element={
                <ProtectedRoute allowedRule="1">
                  <InstallSyrveFrontAll />
                </ProtectedRoute>
              } />
              <Route path="/ChatAi" element={
                <ProtectedRoute allowedRule="0">
                  <ChatAi />
                </ProtectedRoute>
              } />
              <Route path="/Template" element={
                <ProtectedRoute allowedRule="0">
                  <Template />
                </ProtectedRoute>
              } />

              <Route path="/Registr" element={
                <ProtectedRoute allowedRule="1">
                  <Registr />
                </ProtectedRoute>
              } />
              <Route path="/Directory" element={
                <ProtectedRoute allowedRule="1">
                  <Directory />
                </ProtectedRoute>
              } />
       
              <Route path="/UserConfig" element={
                <ProtectedRoute allowedRule="1">
                  <UserConfig />
                </ProtectedRoute>
              } />
              <Route path="/Info" element={
                <ProtectedRoute allowedRule="1">
                  <Info />
                </ProtectedRoute>
              } />

              <Route path="/Profile" element={
                <ProtectedRoute allowedRule="1">
                  <Profile />
                </ProtectedRoute>
              } />
              <Route path="/AdminProfile" element={
                <ProtectedRoute allowedRule="1">
                  <AdminProfile />
                </ProtectedRoute>
              } />
              <Route path="/SuppliersPagePl" element={
                <ProtectedRoute allowedRule="1">
                  <SuppliersPagePl />
                </ProtectedRoute>
              } />
              <Route path="/Events" element={
                <ProtectedRoute allowedRule="1">
                  <Events />
                </ProtectedRoute>
              } />
            
              <Route path="/UserProfile" element={<UserProfile />} />
              <Route path="/ContractorSelector" element={<ContractorSelector />} />
              <Route path="/Login" element={<Login />} />
              <Route path="/Equip" element={<Equip />} />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ResetPassword/:token" element={<ResetPassword />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />
              <Route path="/Price" element={<Price />} />
              
              <Route path="/RestForm" element={
                <ProtectedRoute allowedRule="1">
                  <RestForm />
                </ProtectedRoute>
              } />
              <Route path="/UserManagement" element={
                <ProtectedRoute allowedRule="1">
                  <UserManagement />
                </ProtectedRoute>
              } />
              <Route path="/RestInfo" element={
                <ProtectedRoute allowedRule="1">
                  <RestInfo />
                </ProtectedRoute>
              } />
            
              <Route path="/FopForm" element={
                <ProtectedRoute allowedRule="1">
                  <FopForm />
                </ProtectedRoute>
              } />

              {/* Cases Section Routes (migrated from studio prototype) */}
              <Route path="/CasesComplex" element={
                <ProtectedRoute allowedRule="0">
                  <CasesComplex />
                </ProtectedRoute>
              } />
              <Route path="/CasesPending" element={
                <ProtectedRoute allowedRule="0">
                  <CasesPending />
                </ProtectedRoute>
              } />
              <Route path="/CasesWorking" element={
                <ProtectedRoute allowedRule="0">
                  <CasesWorking />
                </ProtectedRoute>
              } />
              <Route path="/CasesUnprocessed" element={
                <ProtectedRoute allowedRule="0">
                  <CasesUnprocessed />
                </ProtectedRoute>
              } />
            </Routes>
          </AuthProvider>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;